/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Page_Body_HintInputs */

const en_us2_profile_page_body_hint = /** @type {(inputs: Profile_Page_Body_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weight, body fat, measurements and photos`)
};

const pt_br2_profile_page_body_hint = /** @type {(inputs: Profile_Page_Body_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso, gordura, medidas e fotos`)
};

const es_419_profile_page_body_hint = /** @type {(inputs: Profile_Page_Body_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso, grasa corporal, medidas y fotos`)
};

const pt_pt2_profile_page_body_hint = /** @type {(inputs: Profile_Page_Body_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso, gordura, medidas e fotos`)
};

const fr_fr2_profile_page_body_hint = /** @type {(inputs: Profile_Page_Body_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poids, masse grasse, mensurations et photos`)
};

const de_de2_profile_page_body_hint = /** @type {(inputs: Profile_Page_Body_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewicht, Körperfett, Maße und Fotos`)
};

const it_it2_profile_page_body_hint = /** @type {(inputs: Profile_Page_Body_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso, grasso corporeo, misure e foto`)
};

/**
* | output |
* | --- |
* | "Weight, body fat, measurements and photos" |
*
* @param {Profile_Page_Body_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_page_body_hint = /** @type {((inputs?: Profile_Page_Body_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Page_Body_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_page_body_hint(inputs)
	if (locale === "es-419") return es_419_profile_page_body_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_page_body_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_page_body_hint(inputs)
	if (locale === "de-DE") return de_de2_profile_page_body_hint(inputs)
	if (locale === "it-IT") return it_it2_profile_page_body_hint(inputs)
	return en_us2_profile_page_body_hint(inputs)
});
export { profile_page_body_hint as "profile.page_body_hint" }